import { action, makeObservable, observable } from 'mobx';
import { get, post } from 'stores/_services/dataService';

export interface IVsaXIntegration {
    serverName?: string;
    severities?: [];
    sourceTypes?: [];
}

export default class VsaXIntegrationStore {
    integration = {
        serverName: '',
        severities: [],
        sourceTypes: []
    };

    constructor() {
        makeObservable(this, {
            integration: observable,
            update: action,
            checkConnection: action,
            getConfig: action,
            setIntegration: action,
            disconnect: action
        });
    }

    update(integration: IVsaXIntegration): void {
        this.integration = {
            ...this.integration,
            ...integration
        };
    }

    async checkConnection(): Promise<void> {
        const { data } = await get('vsaconfiguration/checkConnection');
        return data;
    }

    async getConfig(): Promise<void> {
        const { data } = await get('vsaconfiguration/config');
        return data;
    }

    async setIntegration(data: any): Promise<void> {
        return await post('vsaconfiguration/connect', {
            serverUrl: data.serverName
        });
    }

    async setSettings(config: any): Promise<void> {
        return await post('vsaconfiguration/config/settings', config);
    }

    async disconnect(): Promise<void> {
        return await get('vsaconfiguration/disconnect');
    }

    async processAuthorizationCode(code: string, state: string): Promise<void> {
        return await post('vsaconfiguration/authcode', { code, state });
    }
}
